import React from "react";

import AppBrandMark from "./AppBrandMark";

export default function StandaloneSystemHeader({
  className = "",
  imageClassName = "block h-auto max-h-10 w-auto max-w-[220px] object-contain",
  glowClassName = "brand-glow",
}) {
  return (
    <div
      data-testid="standalone-system-header"
      className={`mb-6 flex justify-center ${className}`.trim()}
    >
      <AppBrandMark
        containerClassName="flex min-w-0 items-center justify-center"
        badgeClassName="h-10 w-10"
        iconClassName="h-5 w-5"
        textClassName="font-display font-semibold tracking-tight"
        imageClassName={imageClassName}
        glowClassName={glowClassName}
      />
    </div>
  );
}
